import { cx } from '../../utils/cx';
import s from './Badge.module.css';

export type BadgeProps = {
  /** A count (shows "99+" above max). Omit for a plain dot. */
  count?: number;
  max?: number;
  /** Screen-reader text, e.g. "3 gifts to buy". Badges are otherwise decorative. */
  label?: string;
  className?: string;
};

/** Count bubble or dot, positioned by the parent (e.g. on a nav icon). Hidden at 0. */
export function Badge({ count, max = 99, label, className }: BadgeProps) {
  if (count === 0) return null;
  const text = count === undefined ? '' : count > max ? `${max}+` : String(count);
  return (
    <span className={cx(s.badge, className)} data-dot={count === undefined || undefined}>
      <span aria-hidden="true">{text}</span>
      {label ? <span className={s.sr}>{label}</span> : null}
    </span>
  );
}
